export const environment = {
  production: false,
  defaultLocale: 'en',
  availableLocales: ['en', 'de', 'pl']
};
